module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', [_c('div', {
    staticClass: "accordion-item accordionForm"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#",
      "id": "rtp-general-settings"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "form-group row justify-content-start styleGeneral"
  }, [_c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('common.formsSubTitle.gnrl')) + "\n                "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item-content"
  }, [_c('div', {
    staticClass: "form-group d-flex justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('settings.rcv_rqst_to_pay_eml')))]), _vm._v(" "), _c('label', {
    staticClass: "label-switch"
  }, [_c('input', {
    staticClass: "checkboxSendPaymentsRequestEmail",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.canSwitchSendEmail()
    },
    domProps: {
      "checked": _vm.settings.sendPaymentRequestEmail === '1',
      "value": _vm.settings.sendPaymentRequestEmail
    },
    on: {
      "change": _vm.switchSendPaymentsRequestEmail
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group d-flex justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('settings.ngttn_as_dflt')))]), _vm._v(" "), _c('label', {
    staticClass: "label-switch"
  }, [_c('input', {
    staticClass: "checkboxDefaultNegotiationAllowed",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.canSwitchDefaultNegotiation()
    },
    domProps: {
      "checked": _vm.settings.defaultNegotiationAllowed === '1',
      "value": _vm.settings.defaultNegotiationAllowed
    },
    on: {
      "change": _vm.changeSwitchDefaultNegotiationAllowed
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group d-flex justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('settings.activate_OCR')))]), _vm._v(" "), _c('label', {
    staticClass: "label-switch"
  }, [_c('input', {
    staticClass: "checkboxOcrActivation",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.canSwitchOcrActivation()
    },
    domProps: {
      "checked": _vm.settings.ocrActivation === '1',
      "value": _vm.settings.ocrActivation
    },
    on: {
      "change": _vm.changeSwitchOcrActivation
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group d-flex justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('settings.gnrt_bnk_trnsfr_ordr')))]), _vm._v(" "), _c('label', {
    staticClass: "label-switch"
  }, [_c('input', {
    staticClass: "checkboxIsToGenerateXML",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.canSwitchGeneratePain()
    },
    domProps: {
      "checked": _vm.settings.isToGenerateXML === '1',
      "value": _vm.settings.isToGenerateXML
    },
    on: {
      "change": _vm.changeSwitchIsToGenerateXML
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('settings.vldtn_amnt')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.settings.validationThreshold))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.validationThreshold),
      expression: "settings.validationThreshold"
    }],
    staticClass: "range-slider-streammind",
    class: _vm.sliderColorClass,
    attrs: {
      "type": "range",
      "min": "0",
      "max": "150000",
      "value": "0",
      "step": "500",
      "disabled": _vm.canSwitchValidationThreshold()
    },
    domProps: {
      "value": (_vm.settings.validationThreshold)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.settings, "validationThreshold", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', [_c('div', {
    staticClass: "accordion-item accordionForm"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#",
      "id": "rtp-payment-method-settings"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "form-group row justify-content-start styleGeneral"
  }, [_c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('common.formsSubTitle.pymnt_mthd')) + "\n                "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item-content"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "form-group col-sm-auto"
  }, [_c('div', {
    staticClass: "custom-control custom-radio custom-control-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.paymentMethod),
      expression: "settings.paymentMethod"
    }],
    staticClass: "custom-control-input",
    attrs: {
      "id": "defaultInline1",
      "type": "radio",
      "name": "methodRadio",
      "value": "application",
      "disabled": _vm.canSwitchPaymentMethod()
    },
    domProps: {
      "checked": _vm._q(_vm.settings.paymentMethod, "application")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.settings, "paymentMethod", "application")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "defaultInline1",
      "disabled": _vm.canSwitchPaymentMethod()
    }
  }, [_vm._v(_vm._s(_vm.$t('settings.crdt_trnsfr')))])]), _vm._v(" "), _c('div', {
    staticClass: "custom-control custom-radio custom-control-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.paymentMethod),
      expression: "settings.paymentMethod"
    }],
    staticClass: "custom-control-input",
    attrs: {
      "id": "defaultInline2",
      "type": "radio",
      "name": "methodRadio",
      "value": "bankCard",
      "disabled": _vm.canSwitchPaymentMethod()
    },
    domProps: {
      "checked": _vm._q(_vm.settings.paymentMethod, "bankCard")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.settings, "paymentMethod", "bankCard")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "defaultInline2",
      "disabled": _vm.canSwitchPaymentMethod()
    }
  }, [_vm._v(_vm._s(_vm.$t('settings.bnk_crd')))])])])])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', [_c('div', {
    staticClass: "accordion-item accordionForm"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#",
      "id": "rtp-negotiation-settings"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "form-group row justify-content-start styleGeneral"
  }, [_c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('common.formsSubTitle.ngttn')) + "\n                "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item-content"
  }, [_c('div', {
    staticClass: "form-group d-flex justify-content-between",
    staticStyle: {
      "margin-inline": "initial"
    }
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('settings.actvt_ngttn')))]), _vm._v(" "), _c('label', {
    staticClass: "label-switch"
  }, [_c('input', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle",
      value: ('collapse-2'),
      expression: "'collapse-2'"
    }],
    staticClass: "checkboxNegotiationActivated",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.canSwitchNegociation()
    },
    domProps: {
      "checked": _vm.settings.negotiationActivated,
      "value": _vm.settings.negotiationActivated
    },
    on: {
      "change": _vm.switchNegotiationActivated
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "visible": _vm.settings.negotiationActivated === '1',
      "id": "collapse-2"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('settings.ngttn_thrshld')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-auto"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "onkeydown": "return event.keyCode !== 69",
      "placeholder": "Negotiation threshold",
      "value": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('common.installment_number')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-auto"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.defaultInstallmentNumber),
      expression: "settings.defaultInstallmentNumber"
    }],
    staticClass: "installmentSelect button-setting",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.settings, "defaultInstallmentNumber", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((6), function(n) {
    return _c('option', {
      attrs: {
        "min": 2
      },
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n))])
  }), 0)])])])], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-de584a40", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de584a40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/SettingsList/RequestToPaySettings.vue
// module id = 2514
// module chunks = 2